// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"3c3041a3","489":"6eb3d8ba","638":"1ab88da1","716":"b62b2007","963":"c414cdf6","992":"aad87ea1"}[chunkId] + ".css";
};